import React from 'react';

function Footer() {
     return (
          <footer className='bg-[#F1F1F1] p-4 sm:p-6 md:p-8'>
               <div className='max-w-7xl mx-auto text-center md:text-start'>
                    
                    <div className='flex flex-col justify-center items-center text-center gap-y-5 md:grid md:grid-cols-4 md:text-start md:items-start md:gap-4'>
                         <div className=''>
                              <h3 className='font-bold text-lg mb-4 text-black'>
                                   <a href="https://www.icanwewill.com.my/be-informed/">Be Informed</a>
                              </h3>
                              <ul className='space-y-2 text-sm sm:text-base'>
                                   <li><a href="https://www.icanwewill.com.my/be-informed/" className='text-black text-lg hover:text-gray-800 transition-colors'>About Lung Cancer</a></li>
                                   <li><a href="https://www.icanwewill.com.my/be-informed/treatment-of-lung-cancer/" className='text-black text-lg hover:text-gray-800 transition-colors'>Lung Cancer Treatment</a></li>
                                   <li><a href="https://www.icanwewill.com.my/be-informed/treatment-of-lung-cancer-complications/" className='text-black text-lg hover:text-gray-800 transition-colors'>Lung Cancer Complications</a></li>
                                   <li><a href="https://www.icanwewill.com.my/lungx/" className='text-black text-lg hover:text-gray-800 transition-colors'>LungX</a></li>
                                   <li><a href="https://www.icanwewill.com.my/be-informed-breast/" className='text-black text-lg hover:text-gray-800 transition-colors'>About TNBC</a></li>
                                   <li><a href="https://www.icanwewill.com.my/be-informed/treatment-of-breast-cancer/" className='text-black text-lg hover:text-gray-800 transition-colors'>TNBC Treatment</a></li>
                                   <li><a href="https://www.icanwewill.com.my/be-informed/treatment-of-breast-cancer-complications/" className='text-black text-lg hover:text-gray-800 transition-colors'>TNBC Complications</a></li>
                                   <li><a href="https://www.icanwewill.com.my/be-informed/access-to-treatment/" className='text-black text-lg hover:text-gray-800 transition-colors'>Access to Treatment</a></li>
                                   <li><a href="https://www.icanwewill.com.my/be-informed/tips-guidance-overview/" className='text-black text-lg hover:text-gray-800 transition-colors'>Tips & Guidance</a></li>
                                   <li><a href="https://www.icanwewill.com.my/be-informed/in-the-news/" className='text-black text-lg hover:text-gray-800 transition-colors'>News</a></li>
                              </ul>
                         </div>

                         
                         <div className=''>
                              <div>
                                   <h3 className='font-bold text-lg mb-2 text-black'>
                                        <a href="https://www.icanwewill.com.my/be-inspired/" className='hover:text-gray-800 transition-colors'>Be Inspired</a>
                                   </h3>
                              </div>
                              <div>
                                   <h3 className='font-bold text-lg mb-2 text-black'>
                                        <a href="https://www.icanwewill.com.my/be-involved/" className='hover:text-gray-800 transition-colors'>Be Involved</a>
                                   </h3>
                              </div>
                              <div>
                                   <h3 className='font-bold text-lg mb-2 text-black'>
                                        <a href="https://www.icanwewill.com.my/be-connected/" className='hover:text-gray-800 transition-colors'>Be Connected</a>
                                   </h3>
                              </div>
                         </div>

                         
                         <div className='md:col-span-2 md:flex md:justify-end'>
                              <div className='text-center'>
                                   <h3 className='font-bold text-lg mb-4 text-gray-800'>Connect with us</h3>
                                   <div className='flex justify-center space-x-4'>
                                        <a href="#" className='bg-transparent border-2 border-black text-black p-2 sm:p-3 rounded-full hover:bg-gray-700 hover:border-gray-700 transition-colors'>
                                             <img src="./facebook.svg" alt="Facebook" className='h-6 sm:h-8 w-6 sm:w-8' />
                                        </a>
                                        <a href="#" className='bg-transparent border-2 border-black text-black p-2 sm:p-3 rounded-full hover:bg-gray-700 hover:border-gray-700 transition-colors'>
                                             <img src="./twitter.svg" alt="Twitter" className='h-6 sm:h-8 w-6 sm:w-8' />
                                        </a>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className='flex flex-col-reverse md:flex-col border border-t-black border-r-transparent border-b-transparent border-l-transparent mt-10 py-5'>
                         <div className='md:flex md:justify-between md:items-center'>
                              <div className='flex justify-evenly  gap-2 mb-5'>
                                   
                                   <a href="https://www.icanwewill.com.my/#"><img src="./ncsm.png" alt="NCSM" className='mx-2'/></a>
                                   <div className='border border-black'></div>
                                   
                                   <a href="https://www.breastcancer.org.my/"><img src="./bcwa.png" alt="BCWA" className='scale-75 mx-4'/></a>
                                   <div className='border border-black'></div>
                                   
                                   <a
                                        href="https://www.msd-malaysia.com/"
                                        aria-label="Visit MSD Malaysia website"
                                   >
                                        <img src="./msd.png" alt="MSD Malaysia" className='mx-2'/>
                                   </a>
                                   
                                   
                                   
                              </div>
                              <div className='flex justify-center items-center'>
                                   <a href="https://www.essentialaccessibility.com/msd"><img src="./msd-icon.png" alt="Essential Accessibility" className='scale-75'/></a>
                              </div>
                         </div>

                         <div className='flex flex-col mb-4'>
                              <div className='flex flex-col text-center md:text-start md:flex-row md:justify-start'>
                                   <a href="https://www.icanwewill.com.my/be-connected/#about-campaign" className='text-black text-lg hover:text-gray-800 transition-colors'>About the Campaign</a>
                                   <span className='mx-2 text-l hidden md:block '>|</span>
                                   <a href="https://www.msdprivacy.com/" className='text-black text-lg hover:text-gray-800 transition-colors'>Privacy</a>
                                   <span className='mx-2 text-l hidden md:block'>|</span>
                                   <a href="https://www.msd.com/terms-of-use/" className='text-black text-lg hover:text-gray-800 transition-colors'>Terms of Use</a>
                                   <span className='mx-2 text-l hidden md:block'>|</span>
                                   <a href="https://www.icanwewill.com.my/references/" className='text-black text-lg hover:text-gray-800 transition-colors'>Reference</a>
                                   <span className='mx-2 text-l hidden md:block'>|</span>
                                   <a href="https://www.msdaccessibility.com/" className='text-black text-lg hover:text-gray-800 transition-colors'>Accessibility</a>
                              </div>
                              

                         </div>

                    </div>
                    <p className='pb-5 text-xs'>Copyright © 2025 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved. This site is intended for Malaysian residents.</p>
                    <p className='text-xs'> MY-KEY-00944 Mar/2024</p>
               </div>
          </footer>
     );
}

export default Footer;